import { Controller } from "@hotwired/stimulus"
import { applyTheme, currentTheme, getThemeCookie, persistTheme, preferredTheme } from "../lib/theme"

export default class extends Controller {
  connect() {
    this.systemThemeQuery = window.matchMedia("(prefers-color-scheme: dark)")
    this.systemThemeListener = (event) => {
      if (!getThemeCookie()) {
        applyTheme(event.matches ? "dark" : "light")
      }
    }

    this.initializeTheme()
    this.systemThemeQuery.addEventListener("change", this.systemThemeListener)
  }

  disconnect() {
    this.systemThemeQuery?.removeEventListener("change", this.systemThemeListener)
  }

  initializeTheme() {
    const savedTheme = getThemeCookie()
    const theme = savedTheme || preferredTheme()

    this.setTheme(theme)

    if (!savedTheme) {
      persistTheme(theme)
    }
  }

  toggle() {
    const activeTheme = currentTheme()
    const newTheme = activeTheme === "dark" ? "light" : "dark"

    this.setTheme(newTheme)
    persistTheme(newTheme)
  }

  setTheme(theme) {
    applyTheme(theme)
  }
}
